export const navigations = [
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: "dashboard",
    Permissions: [1002, 1102, 1202, 1302, 1402, 1502, 1602],
  },
  {
    name: "Administration",
    icon: "security",
    Permissions: [1002, 1102, 1202, 1302],
    children: [
      {
        name: "Users",
        iconText: "SI",
        path: "/Users/List",
        Permissions: [1102],
      },
      {
        name: "DahiyaMitra",
        iconText: "SU",
        path: "/DahiyaMitra/List",
        Permissions: [1202],
      },
      {
        name: "CLIA M-32 Agents",
        iconText: "CA",
        path: "/CLIA/List",
        Permissions: [1502],
      },

      {
        name: "Inputs",
        iconText: "SU",
        path: "/Inputs",
        Permissions: [1702],
      },
    ],
  },
  {
    name: "Application",
    icon: "apps",
    Permissions: [1302, 1402, 1502, 1602],
    children: [
      {
        name: "Reference",
        iconText: "RF",
        path: "/References/ListReference",
        Permissions: [1402],
      },
      {
        name: "Prospect",
        iconText: "PR",
        path: "/Prospects/ListProspects",
        Permissions: [1302],
      },
      {
        name: "Policy",
        iconText: "PR",
        path: "/Policy/List",
        Permissions: [1602],
      },
      {
        name: "CLIA TEAM DAHIYA",
        iconText: "CL",
        path: "/CLIAProspect/ListCLIAReference",
        Permissions: [1502],
      },
    ],
  },

  {
    name: "Account",
    icon: "account_balance",
    Permissions: [1302, 1402, 1502, 1602],
    children: [
      {
        name: "Account Book",
        iconText: "RF",
        path: "/AccountBook",
        Permissions: [1402],
      },
    ],
  },
  {
    name: "LIC Agency Work",
    icon: "work",
    Permissions: [9994, 9995, 9996, 9997, 9998, 1902, 1802],
    children: [
      {
        name: "Policy Services",
        iconText: "CL",
        path: "/Services/PendingPolicyServices",
        Permissions: [1902],
      },
      {
        name: "LIC BOND",
        iconText: "LB",
        path: "/Services/Bond",
        Permissions: [1902],
      },

      {
        name: "Minor DAB",
        iconText: "MD",
        path: "/Services/MinorDAB",
        Permissions: [1902],
      },
      {
        name: "Minor Nomination",
        iconText: "CL",
        path: "/Services/MinorNomination",
        Permissions: [1902],
      },
      {
        name: "SB Bonus",
        iconText: "SBL",
        path: "/SBBonusList",
        Permissions: [1802],
      },
      {
        name: "LIC Maturity",
        iconText: "LML",
        path: "/LICMaturityList",
        Permissions: [1802],
      },
    ],
  },
  {
    name: "Premium",
    icon: "list",
    Permissions: [1802],
    children: [
      {
        name: "PREMIUM POINT OLD",
        iconText: "LB",
        path: "/PremiumPoint/list",
        Permissions: [1802],
      },

    ],
  },
  {
    name: "Premium New",
    icon: "list",
    Permissions: [1802],
    children: [
      {
        name: "PREMIUM POINT",
        iconText: "LB",
        path: "/PremiumPointNew/list",
        Permissions: [1802],
      }
    ],
  },
  {
    name: "Invoice Data",
    icon: "receipt_long",
    Permissions: [1802],
    children: [
      {
        name: "Invoice List",
        iconText: "LB",
        path: "/LICInvoice/list",
        Permissions: [1802],
      },
      /*       {
              name: "Invoice Import",
              iconText: "LB",
              path: "/LICInvoice/import",
              Permissions: [1802],
            }, */
      {
        name: "Paste & Import",
        iconText: "LB",
        path: "/LICInvoice/ImportByPaste",
        Permissions: [1802],
      },

    ],
  },
  {
    name: "Other",
    icon: "miscellaneous_services",
    Permissions: [2101, 2201, 2301],
    children: [
      {
        name: "Calendar",
        iconText: "CR",
        path: "/Calendar",
        Permissions: [2301],
      },
      {
        name: "Follow ups",
        iconText: "FL",
        path: "/Followups",
        Permissions: [2101],
      },
      {
        name: "Current Month Due List",
        iconText: "CML",
        path: "/CurrentMonthDueList",
        Permissions: [1802],
      },
      {
        name: "Outstanding Due List",
        iconText: "ODL",
        path: "/OutstandingDueList",
        Permissions: [1802],
      },
      {
        name: "Lapsed Due List",
        iconText: "LDL",
        path: "/LapsedPolicyDueList",
        Permissions: [1802],
      },
      {
        name: "E-NACH",
        iconText: "EN",
        path: "/Services/Enach",
        Permissions: [1902],
      },
    ],
  },
  {
    name: "Greeting",
    icon: "card_giftcard",

    Permissions: [2201],
    children: [
      {
        name: "Birthday",
        iconText: "B",
        path: "/Greeting/Birthday",
        Permissions: [1802],
      },
      {
        name: "Anniversary",
        iconText: "A",
        path: "/Greeting/Anniversary",
        Permissions: [1802],
      },
    ],
  },
];
